const pageNameKey = "dropAreaAddFirmware";

export const dropAreaAddFirmwareEn = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Upload or drag & drop",
  },
};

export const dropAreaAddFirmwarePtBr = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Envie ou arraste e solte",
  },
};

export const dropAreaAddFirmwareEs = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Sube o arrastra y suelta",
  },
};

export const dropAreaAddFirmwareDe = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Hochladen oder per Drag & Drop",
  },
};

export const dropAreaAddFirmwareZhHans = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "上传或拖放",
  },
};

export const dropAreaAddFirmwareIt = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Carica o trascina e rilascia",
  },
};

export const dropAreaAddFirmwareNl = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Uploaden of slepen en neerzetten",
  },
};

export const dropAreaAddFirmwareTr = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Yükleyin veya sürükleyip bırakın",
  },
};
